import { getBannerStyles } from "../_publicProfile.styles";

const Banner = () => {
  const { classes } = getBannerStyles({
    baseAssetUrl: window._acctConfig?.BASE_ASSET_URL ?? "",
  });

  return (
    <div className={classes.root}>
      <div className={classes.image} />
      <div className={classes.bottomBackground} />
    </div>
  );
};

export default Banner;
